export enum UserSubscribeNewsletterSource {
  OptinNewsletterSites = 'optin_newsletter_sites',
}

export interface UserSubscribeNewsletterRequestModel {
  email: string;
  optInNewsletter: boolean;
  optInEmailMarketing?: boolean;
  source: UserSubscribeNewsletterSource;
}
